import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));

// 🔹 Captura global do evento beforeinstallprompt
window.addEventListener('beforeinstallprompt', (e: any) => {
  e.preventDefault();
  // Guarda globalmente para acessar depois na HomeComponent
  (window as any).deferredPrompt = e;
});
